import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
    const padding = theme.spacing(2);

    return createStyles({
        field: {
            paddingBottom: theme.spacing(),
        },
        fieldWithSpace: {
            padding: theme.spacing(),
        },
        paneContent: {
            padding,
        },
        spinner: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '80vh',
        },
        dialogContent: {
            width: 600,
            height: 1000,
            [theme.breakpoints.down('xs')]: {
                width: '90%',
                height: '80vh',
            },
        },
    });
});
